import Config from "../config/Config";

import wooApi from "../api/wooApi";
import psApi from "../api/psApi";
import dataApi from "../api/dataApi";

const config = new Config();

export default class WooService {

    categories;
    products;
    variations;
    paymentMethods;

    stripHtml = (element) => {
        return element ? element.replace(/(<([^>]+)>)/gi, "") : null;
    }

    getSystemConfig = async () => {
        return await psApi.get("pdvprinterconfig", {
            params: {
            }
        });
    }

    getCategories = async () => {
        return await wooApi.get("products/categories", {
            params: {
                per_page: 100,
                hide_empty: true
            }
        });
    }

    getProducts = async (page) => {
        return await wooApi.get("products", {
            params: {
                status: 'publish',
                page: page,
                per_page: 100
            }
        });
    }

    getVariations = async (id, page) => {
        return await wooApi.get(`products/${id}/variations`, {
            params: {
                page: page,
                per_page: 100
            }
        });
    }

    getPaymentMethods = async (id) => {
        return await wooApi.get(`payment_gateways`, {
            params: {}
        });
    }

    getOrders = async (id) => {
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 30);
        return await wooApi.get(`orders`, {
            params: {
                after: startDate.toISOString(),
                status: ['on-hold', 'processing', 'pending', 'cancelled', 'completed'],
                per_page: 100
            }
        });
    }

    loadItems = (cart) => {
        const orderItems = cart.items.map(item => {            
            return {
                id: item.id,
                product_id: item.id,
                name: item.name,
                fullName: item.fullName,
                quantity: item.quantity,
                price: item.price,
                total: item.quantity * item.price,
                sku: item.sku
            };
        });
        return orderItems;
    }

    /*
    loadFees = (cart) => {
        const orderFees = cart.fees.map(item => {
            return {
                id: item.id,
                name: item.name,
                quantity: item.quantity,
                price: item.price,
                total: item.quantity * item.price
            };
        });
        return orderFees;
    }

    loadShippings = (cart) => {
        const orderShippings = cart.shippings.map(item => {
            
            return {
                id: item.id,
                name: item.name,
                quantity: item.quantity,
                price: item.price,
                total: item.quantity * item.price
            };
        });
        return orderShippings;
    }
    */

    updateOrder = async (order, cart) => {
console.log('order: ', order);
console.log('cart: ', cart);
        let data = {
            action: 'update',
            status: order.status,
            order_id: order.id,
            line_items: this.loadItems(cart),
            fee_lines: cart.fees,
            shipping_lines: cart.shippings
        }
        return await psApi.post(`update`, data);
    }

    updateOrderStatus = async (order, status) => {
        let data = {
            action: 'status',
            order_id: order.id,
            set_paid: status === 'completed',
            status: status
        }
        return await psApi.post(`update`, data);
    }

    saveDiscount = async (order, discount) => {
        let data = {
            action: 'discount',
            order_id: order.id,
            discount: discount
        }
        return await psApi.post(`update`, data);
    }

    closeOrder = async (order, cart, paymentMethodSelected, isPaid) => {
        let data = {
            action: 'close',
            order_id: order.id,
            set_paid: isPaid,
            status: isPaid ? 'completed' : 'on-hold',
            payment_method: paymentMethodSelected.id,
            payment_method_title: paymentMethodSelected.name,
            line_items: this.loadItems(cart),
            fee_lines: cart.fees,
            shipping_lines: cart.shippings
        }
        return await psApi.post(`update`, data);
    }

    getPrinters = async () => {
        let data = {
            action: 'printers'
        }
        return await psApi.post(`print`, data);
    }

    getOrdersToPrint = async () => {
        return await dataApi.get(config.ORDERS_PATH, {});
    }

    getFileToPrint = async (fileName) => {
        return await dataApi.get(config.ORDERS_PATH + '/' + fileName, {});
    }

    deletePrintedFile = async (fileName) => {
        let data = {
            file_name: fileName
        }
        return await dataApi.post(config.MARK_PRINTED_PATH, data);
    }

    printOrderBill = async (orderId) => {
        let data = {
            action: 'bill',
            order_id: orderId
        }
        return await psApi.post(`print`, data);
    }

    acceptIfoodOrder = async (orderId) => {
        let data = {
            action: 'accept',
            order_id: orderId
        }
        return await psApi.post(`ps-ifood`, data);
    } 

    dispatchIfoodOrder = async (orderId) => {
        let data = {
            action: 'dispatch',
            order_id: orderId
        }
        return await psApi.post(`ps-ifood`, data);
    } 

    cancelIfoodOrder = async (orderId) => {
        let data = {
            action: 'cancel',
            order_id: orderId,
            cancellation_code: 9,
            cancellation_details: 'Dificuldades internas do estabelecimento'
        }
        return await psApi.post(`ps-ifood`, data);
    }

    getWooCategories = async () => {
        try {
            let categoriesList = [];
            const wooCategories = await this.getCategories();
            wooCategories.data.forEach(wooCategory => {
                const image = wooCategory.image ? wooCategory.image.src : null;
                categoriesList.push({ 
                    'id': wooCategory.id,
                    'slug': wooCategory.slug,
                    'name': wooCategory.name.replace(/&amp;/g, "&"),
                    'image': image, 
                    'parent': wooCategory.parent 
                });
            });
            this.categories = categoriesList;
            return categoriesList;
        }
        catch(error) {
            console.log(error);
            return [];
        }
    }

    getProductCategories(wooCategories) {
        let list = [];
        wooCategories.forEach(wooCategory => {
            list.push(wooCategory.id);
        });
        return list;
    }

    getWooProducts = async () => {
        try {
            let productsList = [];
            let wooProducts = [];
            let page = 1;
            let totalPages = 0;
            do {
                const response = await this.getProducts(page);
                wooProducts = [...wooProducts, ...response.data];
                totalPages = response.headers["x-wp-totalpages"];
            } while (page++ < totalPages);
            wooProducts.forEach(wooProduct => {
                if (wooProduct.catalog_visibility === 'visible') {
                    const image = (wooProduct.images.length > 0) ? wooProduct.images[0].src : null;
                    productsList.push({
                        'type': 'item',
                        'id': wooProduct.id,
                        'sku': wooProduct.sku,
                        'status': wooProduct.status,
                        'name': wooProduct.name,
                        'image': image,
                        'description': this.stripHtml(wooProduct.description),
                        'shortDescription': this.stripHtml(wooProduct.shortDescription),
                        'stockStatus': wooProduct.stock_status,
                        'purchasable': wooProduct.purchasable,
                        'menuOrder': wooProduct.menu_order,
                        'quantity': 0,
                        'price': wooProduct.price,
                        'regularPrice': wooProduct.regular_price,
                        'salePrice': wooProduct.sale_price,
                        'categories': this.getProductCategories(wooProduct.categories),
                        'parent' : wooProduct.parent_id,
                        'variations': wooProduct.variations,
                        'children': []
                    });
                }
            });
            productsList.sort((a, b) => (a.menuOrder > b.menuOrder) ? 1 : ((b.menuOrder > a.menuOrder) ? -1 : 0));
            this.products = productsList;

            return productsList;
        }
        catch(error) {
            console.log(error);
            return [];
        }
    }

    buildName = (name, attributes) => {
        let variationName = name;
        let separator = name.length > 0 ? " - " : "";
        attributes.forEach(attribute => {
            variationName += separator + attribute.option;
            separator = "/";
        });
        return variationName;
    }

    getWooVariations = async (id, name) => {
        try {
            let variationsList = [];
            let wooVariations = [];
            let page = 1;
            let totalPages = 0;
            do {
                const response = await this.getVariations(id, page);
                wooVariations = [...wooVariations, ...response.data];
                totalPages = response.headers["x-wp-totalpages"];
            } while (page++ < totalPages);
            wooVariations.forEach(wooVariation => {
                if (wooVariation.status === "publish") {
                    const image = (wooVariation.image) ? wooVariation.image.src : null;
                    variationsList.push({
                        'type': 'item',
                        'id': wooVariation.id,
                        'sku': wooVariation.sku,
                        'name': this.buildName("", wooVariation.attributes),
                        'status': wooVariation.status,
                        'fullName': this.buildName(name, wooVariation.attributes),
                        'price': wooVariation.price,
                        'image': image,
                        'description': this.stripHtml(wooVariation.description),
                        'stockStatus': wooVariation.stock_status,
                        // 'categories': this.getProductCategories(wooVariation.categories),
                        'parent': wooVariation.parent_id
                    });
                }
            });
            this.variations = variationsList;
            return variationsList;
        }
        catch(error) {
            console.log(error);
            return [];
        }
    }

    getWooPaymentMethods = async () => {
        try {
            let paymentMethodsList = [];
            const wooPaymentMethods = await this.getPaymentMethods();
            wooPaymentMethods.data.forEach(wooPaymentMethod => {
                if (wooPaymentMethod.enabled) {
                    paymentMethodsList.push({ 
                        'id': wooPaymentMethod.id,
                        'name': wooPaymentMethod.title
                    });
                }
            });
            this.paymentMethods = paymentMethodsList;
            return paymentMethodsList;
        }
        catch(error) {
            console.log(error);
            return [];
        }
    }

    getAddress = (order) => {
        if (order.created_via === 'rest-api') {
           return null;
        }
        const address = order.billing;
        for (const field in order.shipping) {
            if (order.shipping[field] && order.shipping[field].length > 0) {
                address[field] = order.shipping[field];
            }
        }
        return address;
    }

    getWooOrders = async () => {
        try {
            let ordersList = [];
            const wooOrders = await this.getOrders();
console.log("Orders: ", wooOrders);
            wooOrders.data.forEach(wooOrder => {
console.log("Order: ", wooOrder);
                let items = [];
                for(const item of wooOrder.line_items) {
                    items.push({
                        // id: item.id,
                        id: item.variation_id && item.variation_id > 0 ? item.variation_id : item.product_id,
                        // productId: item.product_id,
                        // variationId: item.variation_id,
                        name: item.name,
                        quantity: item.quantity,
                        price: item.price,
                        // total: item.total,
                        sku: item.sku
                    });
                }
                let fees = [];
                for(const item of wooOrder.fee_lines) {
                    fees.push({
                        id: item.id,
                        name: item.name,
                        quantity: 1,
                        price: item.total,
                    });
                }
                let shippings = []
                for(const item of wooOrder.shipping_lines) {
                    shippings.push({
                        id: item.id,
                        name: item.method_title,
                        quantity: 1,
                        price: item.total,
                        // sku: item.method_id
                    });
                }
                ordersList.push({ 
                    'id': wooOrder.id,
                    'number': wooOrder.number,
                    'origin': wooOrder.created_via,
                    'status': wooOrder.status,
                    'dateCreated': wooOrder.date_created,
                    'firstName': wooOrder.billing.first_name,
                    'lastName': wooOrder.billing.last_name,
                    'total': wooOrder.total,
                    'items': items,
                    'fees': fees,
                    'shippings': shippings,
                    'paymentMethodId': wooOrder.payment_method,
                    'paymentMethodName': wooOrder.payment_method_title,
                    'address': this.getAddress(wooOrder),
                    'customerNotes': wooOrder.customer_note
                });
            });
            this.orders = ordersList;
            return ordersList;
        }
        catch(error) {
            console.log(error);
            return [];
        }
    }

    submitOrder = async (cart, tableId, customerName, customerNotes, paymentMethod, isPaid) => {
        const sanitizedName = customerName.replace(/[^a-zA-Z0-9]/g, '');

        // Store order time on Address 2 field for changing order hash on Bling
        const orderTime = new Date().toLocaleString();
        
        const orderParams = {
            payment_method: paymentMethod.id,
            payment_method_title: paymentMethod.name,
            set_paid: isPaid,
            status: isPaid ? 'completed' : 'on-hold',
            customer_note: customerNotes,
            billing: {
                first_name: customerName.toUpperCase(),
                last_name: "(MESA " + tableId + ")",
                address_1: "Pedido interno",
                address_2: orderTime,
                city: "São Paulo",
                state: "SP",
                postcode: config.POSTAL_CODE,
                country: "BR",
                email: sanitizedName.toLowerCase() + ".mesa" + tableId + "@" + config.CUSTOMER_PREFIX,
                phone: "0"
            },
            line_items: cart.items.map(item => {
                return {
                    product_id: item.id,
                    quantity: item.quantity
                }
            })
        }
        return await wooApi.post(`orders`, orderParams);
    }

    getPaymentLink = async (orderId) => {
        return await psApi.get(`payment`, {
            params: {
                orderId: orderId,
                action: 'getPaymentLink'
            }
        }); 
    }

    getOpenBalance = async () => {
        let data = {
            action: 'getOpenBalance'
        }
        return await psApi.post(`balance`, data);
    }

    openBalance = async (cashValue) => {
        let data = {
            action: 'openBalance',
            openCash: cashValue 
        }
        return await psApi.post(`balance`, data);
    }

    saveOpenBalanceEntry = async (entryValue, entryNotes, type, paymentMethod) => {
        let data = {
            action: 'saveOpenBalanceEntry',
            type: type,
            value: entryValue,
            notes: entryNotes,
            paymentMethod: paymentMethod
        }
        return await psApi.post(`balance`, data);
    }

    closeBalance = async (cashValue, entries) => {
        let data = {
            action: 'closeBalance',
            entries: entries,
            closeCash: cashValue 
        }
        return await psApi.post(`balance`, data);
    }

    getBalanceData = async (balanceId) => {
        return await psApi.get(`balance`, {
            params: {
                balanceId: balanceId,
                action: 'getBalanceData'
            }
        });
    }

}
